import { PdfEngineError } from './errors.ts';

export const V46_STICKER_EXPORT_DPI = 300;
export const V46_STICKER_CUT_LINE_RATIO = 0.0012;
export const V46_STICKER_CUT_LINE_MIN_PX = 1;
export const V46_STICKER_CUT_LINE_OUTER_MARGIN_PX = 1;

export interface V46StickerCutLineMetrics {
  readonly canvasWidthPx: number;
  readonly canvasHeightPx: number;
  readonly shorterSidePx: number;
  readonly lineWidthPx: number;
  readonly lineWidthMm: number;
  readonly insetPx: number;
  readonly insetMm: number;
  readonly outerMarginPx: number;
  readonly outerMarginMm: number;
}

function mmToV46ExportPx(millimeters: number): number {
  return Math.round((millimeters / 25.4) * V46_STICKER_EXPORT_DPI);
}

function pxToV46ExportMm(pixels: number): number {
  return (pixels * 25.4) / V46_STICKER_EXPORT_DPI;
}

export function calculateV46StickerCutLineMetrics(
  widthMm: number,
  heightMm: number,
): V46StickerCutLineMetrics {
  if (!Number.isFinite(widthMm) || widthMm <= 0 || !Number.isFinite(heightMm) || heightMm <= 0) {
    throw new PdfEngineError(
      'PDF_SCENE_INVALID',
      'La formula de linea de corte requiere medidas positivas en mm.',
      { widthMm, heightMm },
    );
  }
  const canvasWidthPx = mmToV46ExportPx(widthMm);
  const canvasHeightPx = mmToV46ExportPx(heightMm);
  const shorterSidePx = Math.min(canvasWidthPx, canvasHeightPx);
  const lineWidthPx = Math.max(
    V46_STICKER_CUT_LINE_MIN_PX,
    Math.round(shorterSidePx * V46_STICKER_CUT_LINE_RATIO),
  );
  const insetPx = lineWidthPx / 2 + V46_STICKER_CUT_LINE_OUTER_MARGIN_PX;
  return {
    canvasWidthPx,
    canvasHeightPx,
    shorterSidePx,
    lineWidthPx,
    lineWidthMm: pxToV46ExportMm(lineWidthPx),
    insetPx,
    insetMm: pxToV46ExportMm(insetPx),
    outerMarginPx: V46_STICKER_CUT_LINE_OUTER_MARGIN_PX,
    outerMarginMm: pxToV46ExportMm(V46_STICKER_CUT_LINE_OUTER_MARGIN_PX),
  };
}
